export default (theme) => ({
  root: {
    margin: 0,
    padding: 10,
    backgroundColor: "#e8e8e8",
  },
  dialogPaper: {
    minHeight: "450px",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: 0,
    color: "#525252",
  },
  panelTitle: {
    fontSize: "1rem",
    fontWeight: "600",
  },
  inputLabel: {
    fontSize: 13,
  },
  switchBase: {
    color: "#52d869",
    "&$checked": {
      color: "#52d869",
    },
    "&$checked + $track": {
      backgroundColor: "#52d869",
    },
  },
  errorText: {
    fontSize: 12,
    color: "#e30613",
  },
  checked: {},
  track: {},
});
